import { ElementNode, Text, View, Show, hexColor, IntrinsicTextNodeStyleProps } from "@lightningtv/solid";
import { Button, ButtonContainer, Column, Row } from "@lightningtv/solid-ui";
import { useParams } from "@solidjs/router";
import {
  createEffect,
  createResource,
  createSignal,
  createSelector,
  //@ts-ignore
  For,
  createMemo,
  onMount,
} from "solid-js";
import { setIsPlaying } from "../../state";
import { useNavigate, useLocation } from "@solidjs/router";
import styles from "../styles";
import * as provider from "../api/providers/entity";
import type { Tile } from "../api/formatters/ItemFormatter";
import videoPlayer from "../video";
import { createInfiniteScroll } from "../components/pagination";
import episodesProvider from "../api/providers/episodesProvider";
import ContentBlockSeries from "../components/ContentBlockSeries";
import LoadingIndicator from "./loading/loading";
import { addSeriesToFavorites, removeSeriesFromFavorites, isSerieFavorite } from "../api/providers/seriesFavorites";
import Header from "../components/Header";
import { fontFamily, isRTL, t } from "../translations/configuration";
import { getImageUrlAbsolute } from "../api";

const RowStyles: any = {
  display: "flex",
  justifyContent: "flexStart",
  width: 300,
  height: 300,
  color: hexColor("00000000"),
  gap: 26,
  y: -110,
} satisfies IntrinsicTextNodeStyleProps;

const columnY = 640;

const Backdrop = {
  color: hexColor("#000000"),
  alpha: 0,
  width: 1900,
  height: 890,
  x: -160,
  y: columnY,
  borderRadius: 30,
};

const SerieDetails = () => {
  const params = useParams();

  let backdropRef: any, seriesRow: any;
  let myButton: any;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let episodesViewRef: any;
  let settingsRef: any, privacyCheck: any, headerRef: any;
  const navigate = useNavigate();
  const [isVideoPlaying, setIsVideoPlaying] = createSignal(false);
  const [isNumberChanging, setIsNumberChanging] = createSignal(false);
  const [number, setNumber] = createSignal(null);
  const [index, setIndex] = createSignal(0);
  const [backImage, setBackImage] = createSignal(0);
  const [isEpsiodesView, setisEpisodesView] = createSignal(false);
  const [episodeTitle, setEpsiodeTitle] = createSignal('');
  const [epsisodeRating, setEpsiodeRating] = createSignal('');
  const [epsisodeDuration, setEpsiodeDuration] = createSignal('');
  const [epsisodeDate, setEpsiodeDate] = createSignal('');
  const stored = JSON.parse(localStorage.getItem("seriesCategoryIDs")) || [];
  const [lockedCategoryIDs, setLockedCategoryIDs] = createSignal(stored);

  const [isFavorite, setIsFavorite] = createSignal(false);



  const [resumeSeason, setResumeSeason] = createSignal(null);
  const [resumeEpisode, setResumeEpisode] = createSignal(null);
  const [resumeSeekTime, setResumeSeekTime] = createSignal(0);
  const [shouldAutoNavigate, setShouldAutoNavigate] = createSignal(false);

  const [resumeSeasonNumber, setResumeSeasonNumber] = createSignal<number | null>(null);
  const [resumeEpisodeNumber, setResumeEpisodeNumber] = createSignal<number | null>(null);



  onMount(() => {
    const searchParams = new URLSearchParams(location.search);
    const season = searchParams.get("resumeSeason");
    const episode = searchParams.get("resumeEpisode");
    const seek = searchParams.get("seek");

    console.log('🔍 URL params:', { season, episode, seek });

    if (season && episode) {
      // Extract numbers from "S1" or "1" format
      const seasonNum = parseInt(season.replace(/\D/g, ''));
      // Extract numbers from "E5" or "5" format
      const episodeNum = parseInt(episode.replace(/\D/g, ''));

      console.log('✅ Parsed resume params:', { seasonNum, episodeNum, seek });

      setResumeSeasonNumber(seasonNum);
      setResumeEpisodeNumber(episodeNum);
      setResumeSeekTime(Number(seek) || 0);
      setShouldAutoNavigate(true);

      console.log(`📺 Resume state set: Season ${seasonNum}, Episode ${episodeNum}, Seek ${seek}ms`);
      console.log('Signals after setting:', {
        resumeSeasonNumber: resumeSeasonNumber(),
        resumeEpisodeNumber: resumeEpisodeNumber(),
        shouldAutoNavigate: shouldAutoNavigate()
      });
    } else {
      console.log('❌ No resume params found');
    }
  });






  const [data] = createResource(() => ({ ...params }), provider.getInfo);

  createEffect(() => {
    const curentData = data();
    if (curentData.backgroundImage()) {

      setBackImage(curentData?.backgroundImage()[0] || curentData.heroContent?.coverImage?.())
    }
  })


  createEffect(() => {
    const seriesId = params.id;

    if (seriesId) {
      const favoriteStatus = isSerieFavorite(seriesId);
      setIsFavorite(favoriteStatus);
      console.log(`Series ${seriesId} favorite status:`, favoriteStatus);
    }
  });


  const [seasons] = createResource<any, Tile[]>(() => ({ ...params }), provider.getSeriesSeasons);

  const providerOfSeries = createMemo(() => {
    //@ts-ignore
    return createInfiniteScroll(episodesProvider(params.filter || "all", number(), index()));
  });

  const isFirst = createSelector(() => {
    return 0;
  });

  const onEscape = () => {
    if (isVideoPlaying() === true) {
      videoPlayer
        .destroy()
        .then(() => {
          console.log("Video player destroyed and video element removed.");
        })
        .catch(error => {
          console.error("Error removing video player:", error);
        });
      setIsVideoPlaying(false);
    } else {
      setIsVideoPlaying(false);

      document.getElementsByTagName("canvas")[0].focus();
      setTimeout(() => navigate("/series"), 100);
      setIsPlaying(true);
    }
  };

  const onEnterSeries = (idSeries: any, title: any, container_extension: any) => {
    const currentData: any = data();
    const posterImage = currentData?.heroContent?.coverImage?.() || "";
    const movieRating = currentData?.heroContent?.rating() || 0;

    navigate(
      `/player?str=${idSeries}&type=series&name=${encodeURIComponent(title)}&extc=${container_extension}&poster=${encodeURIComponent(posterImage)}&rating=${movieRating}&seriesId=${params.id}&season=S${index() + 1}&episode=E1&episodeTitle=${encodeURIComponent(title)}&category=${params.category}`
    );
  };

  const handleNumberChange = (newNumber: any) => {
    if (index() === newNumber()) {
      return;
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setIsNumberChanging(true);
    timeoutId = setTimeout(() => {
      setIndex(newNumber());
      setIsNumberChanging(false);
      timeoutId = null;
    }, 100);
  };

  createEffect(() => {
    if (seasons()) {
      setNumber(params.id);

      // Auto-select season if resuming
      if (shouldAutoNavigate() && resumeSeasonNumber()) {
        const seasonIndex = resumeSeasonNumber() - 1; // Season 1 = index 0

        if (seasonIndex >= 0 && seasonIndex < seasons().length) {
          console.log(`Auto-selecting season index: ${seasonIndex} (Season ${resumeSeasonNumber()})`);

          // Trigger the same logic as clicking on a season
          handleNumberChange(() => seasonIndex);
          setIndex(seasonIndex);
          setisEpisodesView(true);

          // Don't call openEpsiodes here - let it be called by the episodes loading effect
        } else {
          console.warn(`Season ${resumeSeasonNumber()} not found in available seasons`);
        }
      }
    }

    if (videoPlayer) {
      videoPlayer.destroy();
    }
  });


  function DemoTile(props) {
    // Check if this is the episode to resume
    const isResumeEpisode = () => {
      if (!shouldAutoNavigate() || !resumeEpisodeNumber()) return false;
      return (props.index + 1) === resumeEpisodeNumber();
    };

    // Get continue watching progress for this episode
    const getEpisodeProgress = () => {
      try {
        const data = localStorage.getItem("series_continue_watching");
        if (!data) return 0;

        const watchingList = JSON.parse(data);
        const currentSeasonNum = String(index() + 1).padStart(2, '0');
        const currentEpisodeNum = String(props.index + 1).padStart(2, '0');

        // Find matching episode
        const match = watchingList.find(item => {
          const itemSeriesId = String(item.series_id);
          const currentSeriesId = String(params.id);
          const itemSeason = item.season || "";
          const itemEpisode = item.episode || "";

          return (
            itemSeriesId === currentSeriesId &&
            itemSeason === `S${currentSeasonNum}` &&
            itemEpisode === `E${currentEpisodeNum}`
          );
        });

        if (match && match.currentTime && match.duration) {
          const progress = match.currentTime / match.duration;
          return Math.min(Math.max(progress, 0), 1); // Clamp between 0 and 1
        }

        return 0;
      } catch (error) {
        console.error("Error getting episode progress:", error);
        return 0;
      }
    };

    const hasProgress = () => getEpisodeProgress() > 0;

    return (
      <View
        onEnter={() => onEnterSeries(props.id, props.title, props.container_extension)}
        onUp={() => headerRef?.setFocus()}

        onFocus={() => {
          setEpsiodeTitle(props.title);
          setEpsiodeDate(props.info.air_date);
          setEpsiodeDuration(props.info.duration);
          setEpsiodeRating(props.info.rating);
        }}
        states={"active"}
        style={{
          borderRadius: 10,
          width: 390,
          height: 290,
          scale: 1,
          zIndex: 2,
          color: hexColor("#484e55"),
          transition: { scale: { duration: 250, easing: "ease-in-out" } },
          focus: { scale: 1, color: hexColor("#2563eb") },
        }}
      >
        <View>
          {/* Play button icon */}
          <View src={"https://i.ibb.co/6R7bqzr3/play-button-1.png"} width={40} height={40} zIndex={999} x={35} y={223} />

          {/* Episode number text */}
          <Text x={90} y={230} style={{ fontSize: 28, fontFamily: fontFamily() }} zIndex={999} >
            {t("episode")} {props.index + 1}
          </Text>

          {/* Episode thumbnail */}
          <View src={props.info.movie_image
            ? getImageUrlAbsolute(props.info.movie_image)
            : "./assets/television.png"
          } style={{ width: 380, height: 280, borderRadius: 10, x: 5, y: 5 }} />

          {/* Progress bar - only show if there's progress */}
          <Show when={hasProgress()}>
            <View x={5} y={275} style={{ width: 380, height: 10 }}>
              {/* Background bar */}
              <View
                style={{
                  width: 380,
                  height: 10,
                  color: hexColor("#3a3a3a"),
                  borderRadius: 5
                }}
              />
              {/* Progress bar - yellow/gold color */}
              <View
                style={{
                  width: 380 * getEpisodeProgress(),
                  height: 10,
                  color: hexColor("#F5C518"),
                  borderRadius: 5
                }}
              />
            </View>
          </Show>
        </View>
      </View>
    );
  }



  function formatDuration(duration?: string): string {
    console.log('duration', duration());

    if (typeof duration() !== 'string' || !duration().includes(':')) return '';
    const [hours, minutes] = duration().split(':');
    const h = parseInt(hours || '0', 10);
    const m = parseInt(minutes || '0', 10);
    return `${h} h ${m} m`;
  }

  function formatRating(rating?: number | string): string {
    const num = parseFloat(String(rating()));
    return !isNaN(num) ? `${num.toFixed(1)} /10` : '';
  }

  function formatReleaseYear(dateStr?: string): string {
    if (typeof dateStr() !== 'string' || !dateStr().includes('-')) return '';
    const year = dateStr().split('-')[0];
    return /^\d{4}$/.test(year) ? year : '';
  }


  const location = useLocation();
  // location.pathname example: "/entity/movie/666895/736"

  const segments = location.pathname.split("/").filter(Boolean);
  // segments = ["entity", "movie", "666895", "736"]

  const currentCategoryID = segments.length > 0 ? Number(segments[segments.length - 1]) : null;

  console.log("Current categoryID from location:", currentCategoryID);


  function onLock() {
    const seriesId = params.id;
    const currentData: any = data();

    if (!seriesId || !currentData) return;

    const seriesData = {
      series_id: seriesId,
      name: currentData?.heroContent?.title() || "",
      poster: currentData?.heroContent?.coverImage?.() || "",
      category_id: currentCategoryID || "",
      rating: currentData?.heroContent?.rating() || 0,
    };

    if (isFavorite()) {
      // Remove from favorites
      const removed = removeSeriesFromFavorites(seriesId);
      if (removed) {
        setIsFavorite(false);
        console.log("Removed from favorites");
      }
    } else {
      // Add to favorites
      const added = addSeriesToFavorites(seriesData);
      if (added) {
        setIsFavorite(true);
        console.log("Added to favorites");
      }
    }
  }


  // createEffect(() => {

  const openEpsiodes = () => {

    const providers = providerOfSeries().pages(); // get the current value

    console.log('providers', providers);

    if (Array.isArray(providers) && providers.length > 0) {
      setTimeout(() => {

        seriesRow?.setFocus();
      }, 800)
    }
    // });
  }


  // Add a new createEffect to watch for episodes loading
  createEffect(() => {
    const providers = providerOfSeries().pages();

    // If we're auto-navigating and episodes have loaded, focus the row
    if (shouldAutoNavigate() && isEpsiodesView() && Array.isArray(providers) && providers.length > 0) {
      const episodeNum = resumeEpisodeNumber();
      console.log(`Episodes loaded (${providers.length} episodes), setting focus to seriesRow`);
      console.log(`resumeEpisodeNumber signal value:`, episodeNum);
      console.log(`shouldAutoNavigate:`, shouldAutoNavigate());

      const episodeIndex = episodeNum ? episodeNum - 1 : 0;
      console.log(`Auto-focusing episode index: ${episodeIndex} (Episode ${episodeNum || 1})`);

      // Wait a bit for the Row component to fully render
      setTimeout(() => {
        // Try to focus the specific child episode
        if (seriesRow?.children?.[episodeIndex]) {
          seriesRow.children[episodeIndex]?.setFocus();
          console.log(`Focus set to episode ${episodeIndex + 1}`);
        } else {
          // Fallback to focusing the row itself
          seriesRow?.setFocus();
          console.log('Focus set to seriesRow (fallback)');
        }
      }, 500);
    }
  });




  return (
    <Show when={data()}>
      <View src={`${backImage()}`}>

        <View
          onEscape={() => {
            if (isEpsiodesView()) {
              return;
            } else {
              onEscape();
            }
          }}
          src={"https://i.ibb.co/NrtvBBD/hero-mask-inverted.png"}
        >

          <View color={backImage() ? hexColor("#00000000") : hexColor("#182027")}>

            <Header screen={""} ref={(el) => headerRef = el} onDown={() => privacyCheck?.setFocus()} />

            {/* <View x={isRTL() ? 50 : 1700} y={50}>
              <IconButton
                onRef={(el) => { settingsRef = el; }}
                x={100} y={0}
                src="https://i.ibb.co/Jjp8bmn4/setting.png"
                onEnter={() => { navigate("/userInfo") }}
                //onDown={() => entityActions.setFocus()}
              />
            </View> */}

            <View
              onLeft={() => {
                return true;
              }}
            >

              <Show when={!isEpsiodesView()} fallback={
                <View ref={episodesViewRef} onEscape={() => {
                  setTimeout(() => {
                    setisEpisodesView(false)
                  }, 300)
                }} >

                  <Show
                    when={providerOfSeries().pages() && providerOfSeries().pages().length > 0 && !isNumberChanging()}
                    fallback={
                      <View
                        ref={episodesViewRef}
                        autofocus
                        onEscape={() => {
                          setTimeout(() => {
                            setisEpisodesView(false);
                          }, 300);
                        }}
                        x={150}
                        y={300}
                      >
                        {/* @ts-ignore */}
                        <Text fontSize={38}>{data().heroContent.title}</Text>
                        <Text y={100} style={{ fontSize: 25, fontFamily: fontFamily() }}>{t("no_episodes")}</Text>
                      </View>
                    }
                  >
                    {/* @ts-ignore */}
                    <Text fontSize={38} x={isRTL() ? 700 : 100} y={320} fontWeight={isRTL() ? 'normal' : 'bold'} style={{ fontFamily: fontFamily() }}>{data().heroContent.title}</Text>

                    <Row
                      ref={seriesRow}
                      announce="Series"
                      x={100}
                      gap={15}
                      selected={resumeEpisodeNumber() ? resumeEpisodeNumber() - 1 : 0}
                      y={400}
                    >
                      <For each={providerOfSeries().pages()}>
                        {(demo, i) => <DemoTile index={i()} {...demo} />}
                      </For>
                    </Row>

                    <View>
                      <Text fontSize={30} y={750} x={isRTL() ? 700 : 100} fontWeight={isRTL() ? 'normal' : 'bold'} style={{ fontFamily: fontFamily() }}>{episodeTitle()}</Text>

                      {epsisodeRating() && (
                        <View y={795} x={100} direction="row">
                          {Array.from({ length: 5 }).map((_, index) => {
                            const rawRating = epsisodeRating;
                            const rating = rawRating() !== undefined && rawRating() !== null && !isNaN(Number(rawRating()))
                              ? parseFloat(rawRating().toString()) / 2 // Convert from 10 to 5 scale
                              : 0;

                            const fullStars = Math.floor(rating);
                            const hasHalfStar = rating % 1 >= 0.5;

                            const starSrc =
                              index < fullStars
                                ? 'https://i.ibb.co/4gK6MnK/star-1.png' // Full star
                                : index === fullStars && hasHalfStar
                                  ? 'https://i.ibb.co/9V7LVwc/rating.png' // Half star
                                  : 'https://i.ibb.co/1KBsPWh/star-2.png'; // Empty star

                            return (
                              <View
                                key={index}
                                x={index * 35}
                                width={30}
                                height={30}
                                src={starSrc}
                              />
                            );
                          })}
                        </View>
                      )}


                      <View x={200}>

                        <Text y={800} x={100} fontSize={28} color={"#b5b1b1"}>{formatRating(epsisodeRating)}</Text>
                        <Text y={800} x={210} fontSize={28} color={"#b5b1b1"}>| {formatReleaseYear(epsisodeDate)}</Text>
                        <Text y={800} x={300} fontSize={28} color={"#b5b1b1"}>| {formatDuration(epsisodeDuration)}</Text>
                      </View>

                    </View>
                  </Show>
                </View>
              } >

                <View x={isRTL() ? 1000 : 320} y={335}>
                  <View
                    ref={privacyCheck}
                    width={80} height={80}
                    borderRadius={40}
                    style={{
                      color: hexColor("#1a1d24"),
                      border: { width: 0, color: hexColor("#00000000") },
                      focus: {
                        color: hexColor("#1a1d24"),
                        border: { width: 2, color: hexColor("#2563eb") },
                      },
                      transition: { color: { duration: 150 } },
                    }}
                    onEnter={onLock}
                    onUp={() => headerRef?.setFocus()}
                    onDown={() => { myButton?.setFocus() }}
                  >
                    <View
                      x={20} y={20}
                      width={40} height={40}
                      src={
                        isFavorite()
                          ? "https://i.ibb.co/pRyqmgX/icons8-love-100-2.png"
                          : "https://i.ibb.co/kHcHCDb/icons8-love-100.png"
                      }
                    />
                  </View>
                </View>

                <ContentBlockSeries
                  y={200}
                  x={isRTL() ? 800 : 100}
                  content={data().heroContent}
                />

                <Show
                  when={seasons()}
                  fallback={
                    <View x={1000} y={450}>
                      <LoadingIndicator isCategoriesIndicator={true} />
                    </View>
                  }
                >
                  <View x={100} y={520} clipping>
                    <Row
                      transition={{ x: { duration: 350 } }}
                      ref={myButton}
                      gap={20}
                      style={RowStyles}
                      x={isRTL() ? 700 : 0}
                      y={50}
                      scroll="always"
                      onUp={() => { privacyCheck?.setFocus() }}
                    >
                      <For each={seasons()}>
                        {(categorie, i) => {
                          const shouldAutoFocus = () => {
                            if (!shouldAutoNavigate() || !resumeSeasonNumber()) return isFirst(i());
                            return (resumeSeasonNumber() - 1) === i();
                          };

                          return (
                            <View
                              autofocus={shouldAutoFocus()}
                              index={i()}
                              states={"active"}
                              width={258} height={400}
                              borderRadius={14}
                              style={{
                                color: hexColor("#1a1d24"),
                                border: { width: 0, color: 0x00000000 },
                                focus: {
                                  color: hexColor("#1a1d24"),
                                  border: { width: 2, color: 0x2563ebff },
                                },
                                transition: { color: { duration: 150 } },
                              }}
                              onEnter={() => {
                                handleNumberChange(i);
                                setisEpisodesView(true);
                                openEpsiodes();
                              }}
                            >
                              <View
                                x={2} y={2}
                                borderRadius={10}
                                width={253} height={395}
                                src={categorie.cover}
                              />

                              <Text x={10} y={408} style={{
                                fontSize: 24,
                                color: 0xd1d5dbff,
                              }}>
                                {categorie.name}
                              </Text>
                            </View>
                          );
                        }}
                      </For>
                    </Row>
                  </View>
                </Show>


              </Show>
              <View ref={backdropRef} style={Backdrop} transition={{ alpha: true, y: true }} />
            </View>
          </View>
          <View alpha={0} color={hexColor("#000000")} zIndex={200} transition={{ alpha: true }} />
        </View>
      </View>
    </Show>
  );
};

export default SerieDetails;